import { SlicePipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, HostBinding, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { IHomeTop10 } from '@core/models';
import { TranslateModule } from '@ngx-translate/core';
import { CdnUrlPipe } from '@shared/pipes';
import { StringUtil } from '@shared/utils';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { Rating } from '../rating/rating.component';
import { Valoration } from '../valoration/valoration.component';

/**
 * ### **HomeTopTenComponent**
 *
 * **Selector:** ``<app-home-top-ten>``
 *
 * Componente encargado de renderizar la seccion de top 10 que aparece en la página principal.
 * */
@Component({
  selector: 'app-home-top-ten',
  imports: [LazyLoadImageModule, CdnUrlPipe, TranslateModule, SlicePipe, Rating, Valoration],
  templateUrl: "./home-top-ten.component.html",
  styleUrl: "./home-top-ten.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeTopTen {
  private readonly router = inject(Router);

  /** Variable de tipo {@link IHomeTop10} que contendra la información necesaria para renderizar la sección*/
  readonly topTen = input.required<IHomeTop10>();

  /**
   * HostBindinig le permite establecer propiedades en el elemento o componente, en este caso definir clases Css sobre el mismo
   */
  @HostBinding('class') class = 'row';

  constructor() {}

  /**
   * Método que redirige al usuario a la seccion top del item escogido.
   * */
  protected goToTopten(): void {
    this.router.navigate([`topten/${StringUtil.slugify(this.topTen().label.language.title)}`]);
  }
}
